import { CarrierType } from '@planning/app/api'
import { FieldSchema } from 'csv-file-validator'

export type ComparisonType = 'string' | 'number' | 'boolean' | 'stringArray' | 'none' | 'custom'

export interface IFieldConfig extends FieldSchema {
  comparisonType?: ComparisonType
}

const csvHeadersConfigBase: IFieldConfig[] = [
  {
    name: 'Container Number',
    inputName: 'containerNumber',
    required: true,
    comparisonType: 'none',
  },
  {
    name: 'IsoCode',
    inputName: 'isoCode',
    comparisonType: 'string',
  },
  {
    name: 'Gross Weight',
    inputName: 'grossWeight',
    comparisonType: 'custom',
  },
  {
    name: 'ImoClasses',
    inputName: 'imoClasses',
    comparisonType: 'stringArray',
  },
  {
    name: 'IsEmpty',
    inputName: 'isEmpty',
    comparisonType: 'boolean',
  },
  {
    name: 'PortOfLoading',
    inputName: 'portOfLoading',
    comparisonType: 'string',
  },
  {
    name: 'PortOfDischarge',
    inputName: 'portOfDischarge',
    comparisonType: 'string',
  },
  {
    name: 'Operator',
    inputName: 'operator',
    comparisonType: 'custom',
  },
  {
    name: 'Temperature',
    inputName: 'temperature',
    comparisonType: 'string',
  },
  {
    name: 'TypeCode',
    inputName: 'typeCode',
    comparisonType: 'none',
  },
  {
    name: 'FinalDestination',
    inputName: 'finalDestination',
    comparisonType: 'string',
  },
  {
    name: 'UnNumber',
    inputName: 'unNumber',
    comparisonType: 'number',
  },
  {
    name: 'Consignee',
    inputName: 'consignee',
    comparisonType: 'custom',
  },
  {
    name: 'Notes',
    inputName: 'notes',
    comparisonType: 'string',
  },
  {
    name: 'Content',
    inputName: 'content',
    comparisonType: 'string',
  },
  { name: 'HasSeals', inputName: 'hasSeals', comparisonType: 'boolean' },
  { name: 'Seals', inputName: 'seals', comparisonType: 'custom' },
  { name: 'VGM', inputName: 'vgm', comparisonType: 'custom' },
  {
    name: 'IsApproved',
    inputName: 'isApproved',
    comparisonType: 'boolean',
  },
]

const csvHeadersConfigVessel: IFieldConfig[] = [
  ...csvHeadersConfigBase,
  {
    name: 'Shipper',
    inputName: 'shipper',
    comparisonType: 'custom',
  },
  {
    name: 'Forwarder',
    inputName: 'forwarder',
    comparisonType: 'custom',
  },
  {
    name: 'BillOfLading',
    inputName: 'billOfLading',
    comparisonType: 'string',
  },
  {
    name: 'ReleaseReference',
    inputName: 'releaseReference',
    comparisonType: 'string',
  },
  {
    name: 'ShippingOrderReference',
    inputName: 'shippingOrderReference',
    comparisonType: 'string',
  },
  {
    name: 'InlandDestination',
    inputName: 'inlandDestination',
    comparisonType: 'string',
  },
  {
    name: 'PlaceOfOrigin',
    inputName: 'placeOfOrigin',
    comparisonType: 'string',
  },
]

export const csvFieldSchemaMap = new Map<CarrierType, IFieldConfig[] | undefined>([
  [CarrierType.Vessel, [...csvHeadersConfigVessel]],
  [CarrierType.Train, [...csvHeadersConfigBase]],
  [CarrierType.Truck, [...csvHeadersConfigBase]],
  [CarrierType.Universal, undefined],
])
